import { mapValues, sum, valuesIn } from "lodash";

export const getTotalOf = (data, value) => {
    const personal = mapValues(data?.PERSONAL_PROPERTY, value);
    const real = mapValues(data?.REAL_PROPERTY, value);

    return sum([
        ...valuesIn(personal).map(value => value?.docCount),
        ...valuesIn(real).map(value => value?.docCount),
    ]);
};
